
import React, {useState,useRef} from 'react';
import {Link} from "react-router-dom";
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
import {getDomain} from '../../helpers/helpers.js'

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiAddWebsiteResponse, RtMonitoringAddWebsitePageResult} from '../../../../server/routes/monitoring.js'

// interface MonitoringAddWebsitePageData {
//     Domain?: string;
//     MonitoredWebsitesCount?: number;
//     VerifiedDomains?: string[];
// }

interface MonitoringAddWebsiteProps {
    server: string;
    pageData: unknown;
}

export default function MonitoringAddWebsite({server, pageData}: MonitoringAddWebsiteProps) {

    const [data, setData] = useState(pageData as RtMonitoringAddWebsitePageResult);

	return (
        <>
             <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                        <h3 style={{wordWrap: 'break-word'}}>Setup Domain Monitoring</h3>
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <AddMonitorForm   props={data}/> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </>
    )
}

interface FlashState {
    errors?: null;
    success_msg?: string | null;
    error_msg?: string | null;
    error?: string | null;
}

interface AddMonitorFormProps {
    props: RtMonitoringAddWebsitePageResult;
}

// interface ApiResponse {
//     err?: string;
//     results?: {
//         status: string;
//         website?: string;
//     };
// }

function AddMonitorForm({props}: AddMonitorFormProps) {

	const domain = props.Domain;
	const [showControl, setShowControl] = useState<boolean>(false);

    const initialFlashProps: FlashMessageData = {}

	const [flashProps, setFlashProps] = useState(initialFlashProps);

	const domainControl = useRef<HTMLInputElement>(null);
	
	const handleSecurityChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
		setShowControl(event.target.checked);
	};
	
	function clickOwnership(event: React.MouseEvent): void {
		const ownerShipdomain = domainControl.current ? domainControl.current.value : domain;
		window.location.href = ownerShipdomain ? `/user/verified-domains/add-domain?domain=${ownerShipdomain}` : '/user/verified-domains/add-domain';
	}
	
	function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        
        const form = event.currentTarget;
        const websiteInput = form.elements.namedItem('website') as HTMLInputElement;
        const securityInput = form.elements.namedItem('security') as HTMLInputElement;
        const permissionInput = form.elements.namedItem('permissionToScan') as HTMLInputElement;
        const technologyInput = form.elements.namedItem('technology') as HTMLInputElement;
    
        let website = getDomain(websiteInput.value);
        const security = securityInput.checked;       
		const permissionToScan = security && permissionInput.checked;
        const technology = technologyInput.checked;

        setFlashProps({})

		if (website !== undefined && website !== null) {
			website = website.trim();
		}
    
        fetch("/monitoring/api-add-website", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                website,
                technology,
                security,
                permissionToScan
            })
        }).then((response) => {
            return response.json();
        }).then((data: APIResponse<RtApiAddWebsiteResponse>) => {
			console.log(data);

            if (data.err) {
				setFlashProps({error_msg: data.err})
			}
			else
			{
				if (data.results?.status === 'success') {
					setFlashProps({success_msg: 'The website has been added to the monitored list.'} );
					
					setTimeout(() => {
						if ((props.MonitoredWebsitesCount && props.MonitoredWebsitesCount > 0) || !data.results?.website)
							window.location.href = "/monitoring/websites";
						else
							window.location.href = `/monitoring/${data.results.website}`;
					}, 2000 );
					
				} else {
					setFlashProps({error_msg: 'Unexpected error'})
				}
            }
        }).catch((e) => {
            setFlashProps({error: 'Unexpected client error'});
        });
	}
	return (      
		<>    
		<form action="/" method="POST" onSubmit={handleSubmit} >
			<div className="form-group">
				<FlashMessages props={flashProps} />
			</div>
			<div className="form-group">
			<input
					type="domain"
					id="website"
					name="website"
					className="form-control"
					aria-label=""
					placeholder="Input the website name for domain monitoring"
					required
					defaultValue={domain}
					ref={domainControl}
				/>                
			</div>            
			<div className="form-group">
				<input type="checkbox" id="technology" name="technology" defaultChecked={true}/>
				{' '}
				<label htmlFor="technology"> 
				Technology changes monitoring.
				</label>
				<br/>
			</div>		
			<div style={{border: "1px solid grey", padding: "20px"}}>	
				<div className="form-group">
					<input type="checkbox" id="security" name="security" 
						checked={showControl}
						onChange={handleSecurityChange}
						/>
					{' '}
					<label htmlFor="security"> 
					Security monitoring
					</label>
					<br/>
				</div>	
				{
					!!showControl &&
					<>
						<div className="form-group">
							<input type="checkbox" id="permissionToScan" name="permissionToScan"/>
							{' '}
							<label htmlFor="permissionToScan"> 
							I am authorized to conduct security scans on this domain.
							</label>
							<br/>
						</div>							
						<FlashDomainList props={props} />
						<div className="form-group" style={{ display: "flex" }}>		
							<Link 
								className="btn btn-primary" 
								title='Verified Websites list'
								onClick={clickOwnership}
								to='/user/verified-domains/add-domain'
								style={{ marginLeft: "auto", float: 'right' }} 
							>
								Verify Domain Ownership
							</Link>	 
						</div>
	
					</>
				}
			</div>	
			<br/>			
			<div className="form-group" style={{ display: "flex" }}>
			   <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Start monitoring</button>
			</div>
		</form>    

    
	</>
   )
}

function SuccessMessage(domainList: string[] | undefined): string {
    if (!domainList || !domainList.length) return '';

    const domains = domainList.sort();
    let sites = '';
    domains.forEach((d, index) => {
        const isLast = index === domains.length - 1;
        if (sites.length) {
            if (isLast) 
            sites += ` and `;
        else
            sites += `, `;
        }

        sites += `<b>${d}</b>`;
    }) ;

    if (domainList.length >= 6)
        return `You've successfully verified ownership of ${domainList.length} domains. Security monitoring can now be performed on these domains and their subdomains.`;
    if (domainList.length >= 2)
        return `You've verified ownership of ${sites}. You can now perform security monitoring on these domains and their subdomains.`
    else
        return `You've verified ownership of ${sites}. You can now perform security monitoring on this domain and its subdomains.`
}


interface FlashDomainListProps {
    props: RtMonitoringAddWebsitePageResult;
}

interface DomainFlashState {
    success_msg: string;
    error_msg: string;
}

function FlashDomainList({props}: FlashDomainListProps) {
    if (!props) return null;
	
	const domainControl = useRef<HTMLInputElement>(null);
	const website = domainControl.current ? domainControl.current.value : '';
	const domain = getDomain(website);

	const listNotEmpty = (props.VerifiedDomains && !!props.VerifiedDomains.length);
    const success_msg = listNotEmpty ? SuccessMessage(props.VerifiedDomains) : '';
    const error_msg = listNotEmpty ? '' : `You must verify domain ownership before starting security scans.<br/>Just sign up with an <b>email from your domain</b>!`;

    const initialDomains: DomainFlashState = {
		success_msg: success_msg,
		error_msg: error_msg 
    }
	const [flashProps, setFlashProps] = useState<DomainFlashState>(initialDomains);

    return (
        <>
        {
            flashProps.success_msg && flashProps.success_msg.length > 0 &&
            <div className="alert alert-success alert-dismissible fade show" role="alert">
                <div dangerouslySetInnerHTML={{__html: flashProps.success_msg}}/>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        }
        {
            flashProps.error_msg && flashProps.error_msg.length > 0 &&
            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <div dangerouslySetInnerHTML={{__html: flashProps.error_msg}}/>
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        }
    	</>
	)
}